(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var mq = window.matchMedia(MOBILE_QUERY);
  var modal = null;
  var modalImage = null;
  var counter = null;
  var prevButton = null;
  var nextButton = null;
  var closeButton = null;
  var items = [];
  var currentIndex = 0;
  var lastTrigger = null;
  var previousBodyOverflow = '';
  var touchStartX = 0;
  var touchStartY = 0;
  var touchMoved = false;
  var modalTouchStartX = 0;
  var modalTouchStartY = 0;
  var modalHadMultiTouch = false;

  function labels() {
    var isJa = (document.documentElement.lang || '').toLowerCase().indexOf('ja') === 0;
    return isJa
      ? { close: '閉じる', prev: '前の画像', next: '次の画像', dialog: '商品画像を拡大表示' }
      : { close: 'Close', prev: 'Previous image', next: 'Next image', dialog: 'Expanded product image' };
  }

  function collectItems() {
    items = Array.prototype.slice.call(document.querySelectorAll('[data-mrak-gallery-track] [data-mrak-lightbox-item]'));
    return items;
  }

  function resetDesktopZoom() {
    if (modal) modal.classList.remove('is-desktop-zoom');
  }

  function ensureModal() {
    if (modal) return;
    var text = labels();

    modal = document.createElement('div');
    modal.className = 'mrak-mobile-lightbox';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', text.dialog);
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<button type="button" class="mrak-mobile-lightbox__close" aria-label="' + text.close + '">×</button>' +
      '<button type="button" class="mrak-mobile-lightbox__nav mrak-mobile-lightbox__nav--prev" aria-label="' + text.prev + '">←</button>' +
      '<div class="mrak-mobile-lightbox__stage">' +
        '<img class="mrak-mobile-lightbox__image" alt="" decoding="async">' +
      '</div>' +
      '<button type="button" class="mrak-mobile-lightbox__nav mrak-mobile-lightbox__nav--next" aria-label="' + text.next + '">→</button>' +
      '<div class="mrak-mobile-lightbox__counter" aria-live="polite"></div>';

    document.body.appendChild(modal);
    modalImage = modal.querySelector('.mrak-mobile-lightbox__image');
    counter = modal.querySelector('.mrak-mobile-lightbox__counter');
    prevButton = modal.querySelector('.mrak-mobile-lightbox__nav--prev');
    nextButton = modal.querySelector('.mrak-mobile-lightbox__nav--next');
    closeButton = modal.querySelector('.mrak-mobile-lightbox__close');

    closeButton.addEventListener('click', close);
    prevButton.addEventListener('click', function () { show(currentIndex - 1); });
    nextButton.addEventListener('click', function () { show(currentIndex + 1); });

    modalImage.addEventListener('click', function (event) {
      if (mq.matches) return;
      event.stopPropagation();
      modal.classList.toggle('is-desktop-zoom');
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.classList.contains('mrak-mobile-lightbox__stage')) close();
    });

    modal.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        modalHadMultiTouch = true;
        return;
      }
      modalHadMultiTouch = false;
      if (event.touches.length !== 1) return;
      modalTouchStartX = event.touches[0].clientX;
      modalTouchStartY = event.touches[0].clientY;
    }, { passive: true });

    modal.addEventListener('touchmove', function (event) {
      if (event.touches.length > 1) modalHadMultiTouch = true;
    }, { passive: true });

    modal.addEventListener('touchend', function (event) {
      if (modalHadMultiTouch) {
        if (!event.touches || event.touches.length === 0) modalHadMultiTouch = false;
        return;
      }
      if (!event.changedTouches || event.changedTouches.length !== 1) return;
      var dx = event.changedTouches[0].clientX - modalTouchStartX;
      var dy = event.changedTouches[0].clientY - modalTouchStartY;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.25) {
        if (dx < 0) show(currentIndex + 1);
        else show(currentIndex - 1);
      }
    }, { passive: true });
  }

  function show(index) {
    if (!items.length) return;
    resetDesktopZoom();
    currentIndex = (index + items.length) % items.length;
    var item = items[currentIndex];
    var src = item.getAttribute('data-mrak-lightbox-src');
    var alt = item.getAttribute('data-mrak-lightbox-alt') || '';

    if (modalImage.getAttribute('src') !== src) {
      modalImage.removeAttribute('src');
      modalImage.alt = alt;
      modalImage.src = src;
    } else {
      modalImage.alt = alt;
    }

    counter.textContent = (currentIndex + 1) + ' / ' + items.length;
    var showNav = items.length > 1;
    prevButton.hidden = !showNav;
    nextButton.hidden = !showNav;
    counter.hidden = !showNav;
  }

  function open(item) {
    collectItems();
    var index = items.indexOf(item);
    if (index < 0) return;

    ensureModal();
    lastTrigger = item;
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    show(index);
    window.requestAnimationFrame(function () { closeButton.focus(); });
  }

  function close() {
    if (!modal || !modal.classList.contains('is-open')) return;
    resetDesktopZoom();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = previousBodyOverflow;
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus({ preventScroll: true });
  }

  document.addEventListener('touchstart', function (event) {
    var item = event.target.closest && event.target.closest('[data-mrak-lightbox-item]');
    if (!item || !mq.matches || event.touches.length !== 1) return;
    touchStartX = event.touches[0].clientX;
    touchStartY = event.touches[0].clientY;
    touchMoved = false;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (event) {
    var item = event.target.closest && event.target.closest('[data-mrak-lightbox-item]');
    if (!item || !mq.matches || event.touches.length !== 1) return;
    var dx = event.touches[0].clientX - touchStartX;
    var dy = event.touches[0].clientY - touchStartY;
    if (Math.abs(dx) > 10 || Math.abs(dy) > 10) touchMoved = true;
  }, { passive: true, capture: true });

  document.addEventListener('click', function (event) {
    var item = event.target.closest && event.target.closest('[data-mrak-lightbox-item]');
    if (!item) return;
    if (mq.matches && touchMoved) {
      touchMoved = false;
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    open(item);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!modal || !modal.classList.contains('is-open')) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') show(currentIndex - 1);
    if (event.key === 'ArrowRight') show(currentIndex + 1);
  });
})();
